import React from 'react';

// Utils
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import SCOPE from '../../utils/gate/scope';
import withAuth from '../../utils/hocs/withAuth';
import withPermission from '../../utils/hocs/withPermission';
import withSidebar from '../../utils/hocs/withSidebar';

// Services
import useInventoryService from '../../services/inventoryService';

// Components
import PageWrapper from '../../components/layout/PageWrapper/PageWrapper';
import Stocks from '../../components/views/establishment/Stocks/Stocks';
import TableSkeleton from '../../components/views/establishment/Stocks/TableSkeleton';

function ExtraStocks() {
  const { t } = useTranslation();

  const { getProducts } = useInventoryService();

  const { data: products, isFetching } = useQuery('getProducts', () => getProducts({ type: 'EXTRA' }));

  return (
    <PageWrapper
      title={t('stocks.title.extras')}
      hasWhiteWrapper
    >
      {isFetching ? (
        <TableSkeleton />
      ) : (
        <Stocks
          products={products?.data?.products}
          type="extras"
        />
      )}
    </PageWrapper>
  );
}

ExtraStocks.propTypes = {};

export default withAuth(
  withPermission(
    withSidebar(ExtraStocks),
    {
      scopes: [SCOPE.get_ownEst_inventory],
    },
  ),
);
